import { render, staticRenderFns } from "./shopsApply.vue?vue&type=template&id=518aa871"
import script from "./shopsApply.vue?vue&type=script&lang=js"
export * from "./shopsApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports